// Landing page for generic QR scans

import React from 'react';
import { Link } from 'react-router';
import { Search, Library } from 'lucide-react';
import HeroTextPanel from './HeroTextPanel';
import SEO from '../../seo/SEO';
import DocumentGradientCard from '@/content/rendering/documentListings/DocumentGradientCard';

const Scan: React.FC = () => {
  return (
    <div className="min-h-svh bg-background text-foreground">
      <SEO />
      <main className="mx-auto flex min-h-svh w-full max-w-screen-xl items-center justify-center px-6 py-24 sm:px-8 md:px-12 lg:px-16 xl:px-24">
        <section className="flex w-full max-w-5xl flex-col items-center gap-8 sm:gap-10">
          <HeroTextPanel
            title="Nicely done, you scanned a code"
            body="Airhead Games are helping streamers build strong communities. Our party games are also great for teams and game nights."
            className="items-center text-center"
          />
          <div className="grid w-full max-w-3xl grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4">
            <Link
              to="/library"
              className="group block h-full rounded-xl focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
            >
              <DocumentGradientCard
                title="Game Library"
                accentFamily="lime"
                Icon={Library}
                className="h-28 min-h-0 sm:h-32 lg:h-36 xl:h-40"
                titleClassName="text-xl sm:text-2xl lg:text-3xl 2xl:text-4xl"
              />
            </Link>
            <Link
              to="/discover"
              className="group block h-full rounded-xl focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
            >
              <DocumentGradientCard
                title="Discover"
                accentFamily="cyan"
                Icon={Search}
                className="h-28 min-h-0 sm:h-32 lg:h-36 xl:h-40"
                titleClassName="text-xl sm:text-2xl lg:text-3xl 2xl:text-4xl"
              />
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Scan;
